import c from "../utils/common";

export const getProductAvailableQty = (qty, except) => {
  if (!qty) {
    return 0; // If qty is undefined or null, return 0
  }

  let total = qty.total; // Start with the total quantity

  // Create an array of quantities to subtract
  const quantitiesToSubtract = [
    qty.distributed || 0, // Distributed quantity
    qty.estamp || 0, // eStamp quantity
    qty.promotionCode || 0, // Promotion code quantity
    qty.welcome || 0, // Welcome quantity
    qty.sale || 0, // Sale quantity
    qty.referral || 0, // Referral quantity
  ];

  // Check if there's an exception to exclude from subtraction
  if (except) {
    // Create an object to map quantity names to their corresponding indices
    const excludeIndex = {
      distributed: 0,
      estamp: 1,
      promotionCode: 2,
      welcome: 3,
      sale: 4,
      referral: 5,
    };

    // Get the index of the quantity to exclude based on the 'except' parameter
    const indexToExclude = excludeIndex[except];

    // If a valid index is found, set the corresponding quantity to 0 (exclude it)
    if (indexToExclude !== undefined) {
      quantitiesToSubtract[indexToExclude] = 0; // Set the excluded quantity to 0
    }
  }

  // Subtract the quantities from the total
  for (let quantity of quantitiesToSubtract) {
    total -= quantity; // Reduce the total by each quantity in the array
  }

  // Return the maximum between total and 0 to avoid negative values
  return Math.max(total, 0);
};

export const getSellingPrice = (product) => {
  let price =
    product?.discountMethod?.reward?.type == "sellingPrice" ? product?.discountMethod?.reward?.value : product?.price;
  return c.capToTwoDecimals(price);
};
